import { useQuery } from '@apollo/client';
import { usePathname } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import * as S from './PopularRequests.styles';
import { GetPopularRequestsResponse } from '@/api/types/ads.types';
import { GET_POPULAR_REQUESTS } from '@/api/queries/ads.queries';
import { useServerDataContext } from '@/contexts';

export const PopularRequests = () => {
  const { t } = useTranslation();
  const { popularRequests: serverData } = useServerDataContext();
  const pathname = usePathname();
  const { data } = useQuery<GetPopularRequestsResponse>(GET_POPULAR_REQUESTS, {
    variables: { path: pathname },
    notifyOnNetworkStatusChange: true,
  });

  const popularRequests = data?.popularRequests ?? serverData?.popularRequests;

  if (!popularRequests?.length) return null;

  return (
    <S.Box>
      <S.Title>{t('common.popular_requests')}</S.Title>
      <S.Content>
        {popularRequests.map(item => (
          <S.Item key={item.term} href={item.url}>
            {item.term}
          </S.Item>
        ))}
      </S.Content>
    </S.Box>
  );
};

PopularRequests.displayName = 'PopularRequests';
